import { CurrentTimeOfDay } from '@/components/rundown/current-time-of-day.js'

import { useRundown } from '@/features/rundown/rundown.derived'

import formatTimezone from '../../../utils/formatTimezone.js'

export function RundownHeaderTime() {
  const rundown = useRundown()

  const timezone = rundown.timezone
  const todDisplayFormat = rundown.settings.todDisplayFormat

  return (
    <>
      <div className="text-gray-500 font-semibold whitespace-pre text-[10px]">
        Time of day{' '}
        {timezone ? '(' + formatTimezone(timezone, 'abbr') + ')' : ''}
      </div>
      <div className="font-mono text-sm">
        <CurrentTimeOfDay
          timezone={timezone ? timezone : undefined}
          todDisplayFormat={todDisplayFormat ? todDisplayFormat : undefined}
        />
      </div>
    </>
  )
}
